import { render, staticRenderFns } from "./UploadTituloDetalhes.vue?vue&type=template&id=5ddf9a72"
import script from "./UploadTituloDetalhes.vue?vue&type=script&lang=js"
export * from "./UploadTituloDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports